<template>
  <div>
    <vs-popup :title="$t('NotificationText')" :active.sync="showModal">
      <form>
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="DetailsNotification.subject"
            :label="$t('subject')"
            name="subject"
            disabled
          />
        </div>
        <div>
          <vs-textarea
            v-model="DetailsNotification.text"
            name="text"
            :label="$t('text')"
            rows="5"
            disabled
          />
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    show: { default: false },
    DetailsNotification: {}
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  }
};
</script>
